import {enum_loginMethods} from "../../functions/src/shareCode/Share_S_Enum";

const androidFuncNames = {

    android_loginGoogle  : "android_loginGoogle",
    android_loginFacebook: "android_loginFacebook",
    android_logout       : "android_logout",

    android_takeVideo_start  : "android_takeVideo_start",
    android_takeVideo_finish  : "android_takeVideo_finish",
    android_takeImage: "android_takeImage",

    android_scanQrCode        : "android_scanQrCode",
    android_keyboardListener  : "android_keyboardListener",
    android_batteryLevel        : "android_batteryLevel",

    android_pushNotification : "android_pushNotification",

    android_geoLocationListener_set_f : "android_geoLocationListener_set_f",
    android_geoLocationListener_stop_f : "android_geoLocationListener_stop_f",

    android_getVersion : "android_getVersion",
    android_startUpdate : "android_startUpdate",
}

// android_loginWithProvider_f
export const android_loginWithProvider_f = (provider_e, cb_f) => {

    switch (provider_e){
        case enum_loginMethods.google:
            callAndroidFunc_f({
                funcName_s : androidFuncNames.android_loginGoogle,
                cb_f : (idToken_s) =>{
                    cb_f(idToken_s)
                }
            })

            break;
        case enum_loginMethods.facebook:

            callAndroidFunc_f({
                funcName_s  : androidFuncNames.android_loginFacebook,
                cb_f        : (idToken_s) => {cb_f(idToken_s)}
            })

            break;

    }



}

// android_logout_f
export const android_logout_f = (cb_f) => {

    callAndroidFunc_f({
        funcName_s  : androidFuncNames.android_logout,
        cb_f        : cb_f
    })

}

// android_takeVideo_f
export const android_takeVideo_f = (cb_f) => {


    callAndroidFunc_f({
        funcName_s  : androidFuncNames.android_takeVideo_start,
        cb_f        : cb_f
    })

}

// android_takeVideo_finish_f
export const android_takeVideo_finish_f = (cb_f) => {
    callAndroidFunc_f({funcName_s : androidFuncNames.android_takeVideo_finish});
}

// android_takeImage_f
export const android_takeImage_f = (cb_f) => {

    callAndroidFunc_f({
        funcName_s  : androidFuncNames.android_takeImage,
        cb_f        : cb_f
    })



}

// android_qrScanner_f
export const android_qrScanner_f = (cb_f) => {

    callAndroidFunc_f({
        funcName_s  : androidFuncNames.android_scanQrCode,
        cb_f        : (qrCode_s) =>{
            cb_f(qrCode_s)
        }});
}

// android_getBatteryLevel_f
export const android_getBatteryLevel_f = (cb_f) => {


    callAndroidFunc_f({
        funcName_s  : androidFuncNames.android_batteryLevel,
        cb_f        : (val) => {
            cb_f(parseInt(val));
        }})

}

// android_setKeyboardOnChangeListener_f
export const android_setKeyboardOnChangeListener_f = (cb_f) => {

    callAndroidFunc_f({
        funcName_s  : androidFuncNames.android_keyboardListener,
        cb_f        : (keyboardStatus_b) => {
            cb_f(JSON.parse(keyboardStatus_b))
        }})

}

// android_notification_chat
export const android_notification_chat = (title, content) => {
    callAndroidFunc_f({
        funcName_s  : androidFuncNames.android_pushNotification,
        data_o      : {title_s: title, content_s : content}
    })
}

// app_geoLocationListener_set_f
export const android_geoLocationListener_set_f = (cb_f) => {
    callAndroidFunc_f({
        funcName_s  : androidFuncNames.android_geoLocationListener_set_f,
        cb_f        : (location_o) => {
            cb_f(JSON.parse(location_o))
        }})
}

// app_geoLocationListener_stop_f
export const android_geoLocationListener_stop_f = () => {
    callAndroidFunc_f({
        funcName_s : androidFuncNames.android_geoLocationListener_stop_f,
        cb_f       : () => {},
    })
}

// android_getVersion_f
export const android_getVersion_f = (cb_f) => {

    callAndroidFunc_f({
        funcName_s : androidFuncNames.android_getVersion,
        cb_f : cb_f
    })

}

// android_getVersion_f
export const android_startUpdate_f = (cb_f) => {

    callAndroidFunc_f({
        funcName_s : androidFuncNames.android_startUpdate,
    })

}

// =========== local functions =======

// callAndroidFunc_f
const callAndroidFunc_f = ({funcName_s, cb_f=null, data_o = {}}) => {

    let cbName_s = getCallBackName(funcName_s)
    window[cbName_s] = cb_f

    if(Android[funcName_s] != null){
        Android[funcName_s](cbName_s, JSON.stringify(data_o))
    }else{
        console.log("not a function " + funcName_s)
    }
}

// getCallBackName
const getCallBackName = (funcName_s) => {
    return funcName_s + "_cb"
}

// b64toByteArr
const b64toByteArr = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return byteArrays

}


